import { invokeApi } from "../../bl_libs/invokeApi";

const auth = () => ({ "x-sh-auth": localStorage.getItem("token") });

// GET /api/marketing/funnel/overview?days=30 (or startDate/endDate, optionally &channel=...)
// Returns { since, until, channel, channels[], adFunnel, conversionFunnel,
//           onboardingFunnel, paymentBreakdown, comparison, stripeRevenue }
export const get_marketing_funnel_overview_api = async ({ days, startDate, endDate, channel } = {}) => {
  const params = new URLSearchParams();
  if (startDate && endDate) {
    params.set("startDate", startDate);
    params.set("endDate", endDate);
  } else {
    params.set("days", days || 30);
  }
  if (channel) params.set("channel", channel);

  return invokeApi({ path: `api/marketing/funnel/overview?${params.toString()}`, method: "GET", headers: auth() });
};

// POST /api/marketing/assistant/chat
// body: { message, conversationHistory: [{role, content}], context: {days, startDate, endDate, channel} }
// Returns { message }
export const post_marketing_assistant_chat_api = async (data) => {
  return invokeApi({ path: `api/marketing/assistant/chat`, method: "POST", postData: data, headers: auth() });
};
